import { useTemplateAuditLog } from '@/api/queries/templates';
import { auditActionLabels, auditDateFormatter } from '@/features/templates/template-ui';

/**
 * Journal des actions d'un template : qui a créé, modifié, publié ou archivé, et quand.
 *
 * Distinct des colonnes d'audit de la ligne (`created_by`, `last_modified_by`), qui ne
 * retiennent que le DERNIER auteur : elles répondent à « qui y a touché en dernier », jamais
 * à « qui a publié ce template, et qui l'a archivé trois jours plus tard ».
 */
export function TemplateAuditPanel({ templateId }: { templateId: string }) {
  const audit = useTemplateAuditLog(templateId, true);

  if (audit.isPending) {
    return <p className="text-xs text-ink-500">Chargement de l’historique…</p>;
  }

  if (audit.isError) {
    return <p className="text-xs text-danger-500">Impossible de charger l’historique.</p>;
  }

  if (!audit.data || audit.data.length === 0) {
    // Les templates créés avant la mise en place du journal n'ont aucune entrée : le dire
    // explicitement évite de laisser croire à un chargement qui n'aboutit pas.
    return <p className="text-xs text-ink-500">Aucune action enregistrée pour ce template.</p>;
  }

  return (
    <ol className="flex flex-col gap-2 rounded-lg bg-ink-50 p-3">
      {audit.data.map((entry) => (
        <li key={entry.id} className="text-xs text-ink-700">
          <span className="font-medium">{auditActionLabels[entry.action] ?? entry.action}</span>
          {entry.details ? <span className="text-ink-500"> · {entry.details}</span> : null}
          <br />
          <span className="text-ink-500">
            {entry.actorName ?? 'Auteur inconnu'} · {auditDateFormatter.format(new Date(entry.createdAt))}
          </span>
        </li>
      ))}
    </ol>
  );
}
